import styled from "styled-components";

export const Button = styled.a`
  border-radius: 3px;
  border: solid 1px #66b752;
  padding: 3px 5px;
  font-family: 'AvenirNext-DemiBold';
  color: #fff;
  cursor: pointer;
  background-color: #66b752;
  text-decoration: none;
  display: inline-block;
`;